var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoachHomescreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 58 58",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87339 29C1.87339 14.0184 14.0184 1.87339 29 1.87339C43.9816 1.87339 56.1266 14.0184 56.1266 29C56.1266 43.9816 43.9816 56.1266 29 56.1266C14.0184 56.1266 1.87339 43.9816 1.87339 29Z",
    fill: "#b394b3",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#9a739a",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5012 34.9437C50.5043 35.5711 49.998 36.082 49.3675 36.0828L43.6919 36.099C43.0652 36.1013 42.5574 35.592 42.5566 34.9668C42.5535 34.3371 43.0606 33.8285 43.6857 33.8254L49.3621 33.8115C49.9903 33.8115 50.4997 34.3178 50.5012 34.9437",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6983 28.7132C48.9692 29.2789 48.7261 29.9565 48.1597 30.2259L43.032 32.6608C42.4671 32.9301 41.7902 32.687 41.5224 32.1206C41.2492 31.5572 41.4931 30.8795 42.0588 30.6087L47.1857 28.1737C47.7529 27.9059 48.4282 28.1467 48.6983 28.7132",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7323 41.1873C48.9986 40.6177 48.7547 39.9432 48.1874 39.677L43.0467 37.2683C42.4787 36.9989 41.8041 37.2443 41.5371 37.8108C41.2708 38.3788 41.5155 39.0557 42.0843 39.3204L47.2227 41.7314C47.79 41.9984 48.4676 41.7538 48.7323 41.1873",
    fill: "#000000",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.5795 25.5458C40.7734 25.3081 40.0092 24.8692 39.3836 24.3898C38.7579 23.9105 38.271 23.3907 38.0194 22.9913C37.5879 22.3059 37.6321 21.8743 37.7403 21.1361C37.8484 20.3979 38.0205 19.3532 37.8449 17.4415C37.6833 15.6911 36.3977 13.8747 34.4201 12.4482C32.4425 11.0217 29.773 9.98502 26.8434 9.794C25.5124 9.70718 24.1545 9.7996 22.7745 10.1077C21.3945 10.4159 19.9923 10.9397 18.5731 11.7157C14.9291 13.7088 12.385 16.8117 11.4555 20.4333C10.526 24.055 11.2111 28.1953 14.0258 32.2633C16.563 35.9304 16.6413 38.5924 16.0854 40.3377C15.5294 42.0829 14.3391 42.9114 14.3391 42.9114C14.3391 42.9114 14.3864 43.2975 14.8236 43.9428C15.2608 44.5881 16.088 45.4926 17.6477 46.5295C19.2082 47.5675 20.9455 47.7346 22.2926 47.6422C23.6397 47.5498 24.5967 47.1979 24.5967 47.1979C24.5967 47.1979 24.9124 46.0759 25.7441 45.0055C26.5757 43.9352 27.9234 42.9165 29.9875 43.1229C31.467 43.3402 33.2452 43.3039 34.7849 43.0862C36.3246 42.8684 37.6258 42.4692 38.1513 41.9606C38.643 41.4852 38.5999 40.9498 38.532 40.2016C38.4641 39.4533 38.3713 38.4923 38.7633 37.1656C37.4209 37.034 36.3809 36.6481 35.6588 36.0695C34.9367 35.4909 34.5325 34.7195 34.4615 33.8169C35.9514 33.962 37.0033 33.798 37.7894 33.4676C38.5754 33.1372 39.0956 32.6403 39.522 32.1198C39.5104 31.8138 39.4894 31.3355 39.4638 30.8246C39.4383 30.3138 39.4082 29.7705 39.3784 29.3345C40.6959 28.9528 41.6065 28.1122 42.0077 27.3137C42.4088 26.5152 42.3004 25.7588 41.5795 25.5458",
    fill: "#ffcc9b",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoachHomescreen);
export default __webpack_public_path__ + "static/media/icon_coach_homescreen.13e5938ecf71c131bbf6f164f3919371.svg";
export { ForwardRef as ReactComponent };